//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//import FullWidthVideo from "~/components/video-elements/fullWidthVideo.vue";
export default {
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  components: {
    //FullWidthVideo,
  },
  mounted() {
    // this.$router.push({ path: "/media/videos", query: this.data.id });
  },
  methods: {
    // useMoment(videoListData) {
    //   if (videoListData != "") {
    //     return this.$moment(videoListData).format("MMM DD, YYYY");
    //   }
    // },
    copyLink() {
      let linkToCopy = document.querySelector("#ytURL");
      linkToCopy.setAttribute("type", "text");
      linkToCopy.select();
      var successful = document.execCommand("copy");
      if (successful) {
        this.$bvToast.toast("Link copied", {
          title: `Success`,
          variant: "success",
          solid: true,
        });
      } else {
        this.$bvToast.toast("Unable to copy", {
          title: `Error`,
          variant: "danger",
          solid: true,
        });
      }
      /* unselect the range */
      linkToCopy.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    },
  },
};
